import React, { useState } from 'react';
import styles from './VehicleInfo.module.scss';
import { Image } from '@tme/toyota-common';
import classNames from 'classnames';
import { BrandCode, FuelType, VehicleDetails } from '../../@types/dataTypes';
import { CONSTANTS } from '../../constants/constants';
import { removeBrandAndFuelTypeFromModel } from '../../tools/tools';

const { VEHICLE_DEFAULT_IMAGE_URL } = CONSTANTS;

export default function VehicleInfo({
	modelName,
	fuelType,
	modelYear,
	imageUrl,
	brandCode
}: VehicleDetails): React.JSX.Element {
	const [vehicleImageError, setVehicleImageError] = useState(false);

	const handleVehicleImageError = (
		e: React.SyntheticEvent<HTMLImageElement, Event>
	): void => {
		e.currentTarget.onerror = null;
		e.currentTarget.src = VEHICLE_DEFAULT_IMAGE_URL;
		setVehicleImageError(true);
	};
	const vehicleInfo =
		brandCode && Object.keys(BrandCode).includes(brandCode)
			? `${BrandCode[brandCode as unknown as keyof typeof BrandCode]} ${
					modelName && removeBrandAndFuelTypeFromModel(modelName)
			  }`
			: ``;

	const fuelInfo =
		fuelType && Object.keys(FuelType).includes(fuelType)
			? `${FuelType[fuelType as unknown as keyof typeof FuelType]}`
			: ``;

	return (
		<div className={styles.uioWrapper}>
			<div className={`${styles.vehicleData}`}>
				<div className={`${styles.vehicleData} ${styles.uppercase}`}>
					{vehicleInfo}
				</div>
				<div className={`${styles.vehicleData} ${styles.uppercase}`}>
					{fuelInfo}
				</div>
				<div className={`${styles.vehicleData} ${styles.year}`}>
					{modelYear}
				</div>
			</div>
			<div className={styles.vehicleImage}>
				<Image
					imageUrl={
						vehicleImageError
							? VEHICLE_DEFAULT_IMAGE_URL
							: imageUrl || VEHICLE_DEFAULT_IMAGE_URL
					}
					onErrorFn={handleVehicleImageError}
					testId={`cp-car-image`}
					options={{
						shouldFadeIn: true,
						shouldLazyLoad: true
					}}
					key={modelYear}
					className={classNames({
						[styles.vehicleImage]:
							!vehicleImageError && Boolean(imageUrl),
						[styles.defaultImage]: vehicleImageError || !imageUrl
					})}
					alt={`${vehicleInfo} image`}
				/>
			</div>
		</div>
	);
}
